var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv layout=\"row\" layout-padding\u003E\u003Cdiv\u003E\u003Cmd-icon\u003E{{$ctrl.icon}}\u003C\u002Fmd-icon\u003E\u003C\u002Fdiv\u003E\u003Csection flex\u003E\u003Cdiv class=\"md-body-2\"\u003E{{$ctrl.title}}\u003C\u002Fdiv\u003E\u003Cdiv ng-transclude\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Cmd-divider\u003E\u003C\u002Fmd-divider\u003E";;return pug_html;};
module.exports = template;


// WEBPACK FOOTER //
// ./app/shared/components/wizard-step/wizard-step.template.pug